<form #editForm="ngForm">
  <div fxLayout="row wrap" fxLayoutGap="10px">
    <mat-form-field appearance="legacy" style="padding-bottom: 10px;width: 180px">
      <mat-label>予定日</mat-label>
      <input matInput [matDatepicker]="yoteiDatePicker" [(ngModel)]="eventEditForm.yoteiDate" name="yoteiDate" readonly
             (click)="yoteiDatePicker.open()" (dateChange)="updateEventEditFormYoteiNichirei(eventEditForm)">
      <mat-datepicker-toggle matSuffix [for]="yoteiDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #yoteiDatePicker></mat-datepicker>
    </mat-form-field>
  </div>
  <div fxLayout="row wrap" fxLayoutGap="10px" *ngIf="!commonService.isUndefined(eventEditForm.yoteiNichirei)">
    <mat-form-field>
      <mat-label>
        予定日齢
      </mat-label>
      <input matInput placeholder="予定日齢" type="number" min="0"
             name="yoteiNichirei" [(ngModel)]="eventEditForm.yoteiNichirei"
             (change)="updateEventEditFormYoteiDate(eventEditForm)">
    </mat-form-field>
  </div>
  <br>
  <button mat-raised-button color="primary" [disabled]="editForm.invalid"
          (click)="updateEventYoteiDate(eventEditForm, selectedMeisais);" style="margin-right: 12px;margin-bottom: 12px">登録
  </button>
</form>
